import { HeartIcon } from "@heroicons/react/24/outline";
import { useQuery } from "@tanstack/react-query";

import Headline from "~/components/Headline/Headline";
import { AbsenceTypeId } from "~/modules/absence/api/absence/absenceTypes.ts";
import { sickDayQueries } from "~/modules/absence/api/sickDay/sickDayQueries.ts";
import { useAbsenceActions } from "~/modules/absence/hooks/useAbsenceActions.tsx";
import { sickNoteSteps } from "~/modules/absence/utils/sickNoteSteps.ts";
import { AddPillButton } from "~/modules/dashboard/components/AddPillButton.tsx";
import { FigureRow } from "~/modules/dashboard/components/FigureRow.tsx";
import { StepList } from "~/modules/dashboard/components/StepList.tsx";
import { formatNumberWithComma } from "~/utils/numberUtils.ts";

type Props = {
	staffMemberId: string;
};

export function SickDayBox({ staffMemberId }: Props) {
	const year = new Date().getFullYear();
	const { data, isPending, isError } = useQuery(sickDayQueries.byYear(staffMemberId, year));
	// The "+" opens the create sidebar only, so the hook gets no absence lists.
	const { dialogs, openCreate } = useAbsenceActions({ absences: [], absenceTypes: [], staffMemberId });

	return (
		<div>
			<div className="mb-3 flex min-h-7 items-center justify-between gap-2">
				<Headline type="h3" size="lg" weight="semibold">Krankmeldung</Headline>
				<AddPillButton label="Krankmeldung eintragen"
							   onClick={() => openCreate({ absenceTypeId: AbsenceTypeId.Sick })} />
			</div>
			<div className="rounded-lg border border-gray-200 bg-white p-3">
				{isError && <p className="text-sm text-gray-500">Die Krankheitstage konnten nicht geladen werden.</p>}
				{!isError && (
					<dl>
						<FigureRow icon={HeartIcon}
								   label="Krankheitstage"
								   value={data ? formatNumberWithComma(data.sickDays, 1, true) : ""}
								   isLoading={isPending} />
					</dl>
				)}
				<div className="mt-3 border-t border-gray-200 pt-3">
					<StepList steps={sickNoteSteps} />
				</div>
			</div>
			{dialogs}
		</div>
	);
}
